import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';

const AndroidIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M8.5 15C9.19036 15 9.75 14.4404 9.75 13.75C9.75 13.0596 9.19036 12.5 8.5 12.5C7.80964 12.5 7.25 13.0596 7.25 13.75C7.25 14.4404 7.80964 15 8.5 15Z"
        fill={iconColor}
      />
      <Path
        d="M15 15C15.6904 15 16.25 14.4404 16.25 13.75C16.25 13.0596 15.6904 12.5 15 12.5C14.3096 12.5 13.75 13.0596 13.75 13.75C13.75 14.4404 14.3096 15 15 15Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.04289 4.29289C2.43342 3.90237 3.06658 3.90237 3.45711 4.29289L5.75938 6.59517C7.45745 5.43878 9.50227 4.75776 11.7118 4.75007C13.1267 4.74503 14.5287 5.01938 15.8373 5.55736C16.5106 5.83414 17.1524 6.1779 17.7533 6.58246L20.0429 4.29289C20.4334 3.90237 21.0666 3.90237 21.4571 4.29289C21.8476 4.68342 21.8476 5.31658 21.4571 5.70711L19.3084 7.85583C19.3182 7.86557 19.3281 7.87533 19.3379 7.88512C20.3402 8.88385 21.1354 10.0706 21.6781 11.3774C22.2207 12.6841 22.5 14.0851 22.5 15.5001V17.7501C22.5 18.2142 22.3156 18.6593 21.9874 18.9875C21.6592 19.3157 21.2141 19.5001 20.75 19.5001H2.75C2.28587 19.5001 1.84075 19.3157 1.51256 18.9875C1.18437 18.6593 1 18.2142 1 17.7501V15.606C1 12.5987 2.22559 9.85298 4.21106 7.87527L2.04289 5.70711C1.65237 5.31658 1.65237 4.68342 2.04289 4.29289ZM17.2062 8.6595C17.2207 8.67184 17.2355 8.6837 17.2505 8.69507C17.4856 8.88514 17.7112 9.08762 17.9262 9.30184C18.742 10.1148 19.3893 11.0807 19.831 12.1444C20.2727 13.208 20.5 14.3484 20.5 15.5001V17.5001H3V15.606C3 10.754 6.89507 6.76684 11.7188 6.75006C12.8705 6.74596 14.0117 6.96926 15.0769 7.40715C15.8438 7.72243 16.5605 8.14447 17.2062 8.6595Z"
        fill={iconColor}
      />
    </Svg>
  );
};

export default AndroidIcon;
